import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StylesheetComponent } from './stylesheet.component';

const routes: Routes = [{ path: 'stylesheet', component: StylesheetComponent, data: { title: 'Stylesheet' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StylesheetRoutingModule {}
